// extracted by mini-css-extract-plugin
export default {"transitionForm":"TransitionForm_transitionForm__DyprT","formActions":"TransitionForm_formActions__D3RSb"};